import { AnyAction } from 'redux';

import { validateNamespace } from '../validateNamespace/validateNamespace';

export interface INamespaceActionCreator {
    (...args: any[]): AnyAction;
}

export interface INamespaceActionCreatorFactory {
    (actionType: string, actionCreator?: any): INamespaceActionCreator;
}

export function createNamespaceActionCreatorFactory (namespace: string): INamespaceActionCreatorFactory {
    validateNamespace(namespace);

    return (actionType: string, actionCreator: any = (): null => {
        return null;
    }): INamespaceActionCreator => {
        return (...actionArgs: any[]): AnyAction => {
            return {
                payload: actionCreator(...actionArgs),
                type: actionType,
                namespace: namespace,
            };
        };
    };
}